module.exports = __webpack_public_path__ + "img/sb.b9736078.svg";